<template>
    <b-badge :variant="c_status.variant">{{c_status.text}}</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object
    },
    computed:{
        c_status(){
            if(this.row?.WrongPlateReason == 0){
                return { variant:'danger',text:'Envanterde Yok' }
            }else if(this.row?.WrongPlateReason == 1){
                return { variant:'secondary',text:'Satılmış Plaka' }
            }else{
                return { variant:'warning',text:'Veri Yok' }
            }
            
        }
    }
}
</script>

<style>

</style>